#admin-scheduling_links_show .fc-timegrid-bg-harness {
  pointer-events: none;
}

#admin-scheduling_links_show .calendar-component .fc-header-toolbar {
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px; // FullCalendar's 1.5em leaves a hole above the hint + legend row

  .calendar-nav-buttons {
    flex-wrap: wrap;
    justify-content: flex-end;
    max-width: 100%;
    margin-left: auto;
  }

  // Time zone pill + time off / free slots / overlay buttons: the buttons drop to a new line
  // instead of sliding under the pill.
  [data-calendar-target='overlayToggle'] {
    flex-wrap: wrap;
    justify-content: flex-end;
  }
}

// Day headers carry a "Block" button (always shown in the See it all view). When the weekday,
// date and button don't fit on one line, every column stacks them the same way: weekday, date,
// button, centered. Letting the row wrap on its own stacked some days and not others.
#admin-scheduling_links_show .calendar-component .fc-col-header-cell-cushion {
  container-type: inline-size;

  @container (max-width: 140px) {
    > span {
      flex-direction: column;
      row-gap: 2px;
    }

    [data-scheduling-header-controls] {
      margin-left: 0;
    }
  }

  // Very narrow columns: a compact button so neighbors don't run into each other.
  @container (max-width: 64px) {
    [data-scheduling-block-day] {
      padding-inline: 2px;
      font-size: 11px;
    }
  }
}

.calendar-component.calendar-component.calendar-component {
  --fc-today-bg-color: transparent;

  &:is(.dark *) {
    --fc-border-color: var(--tw-color-neutral-800);
  }

  // Admin only: the public booking page shares this component and keeps its colors.
  // The admin body text color is light-only, so the title and date numbers vanish in dark,
  // and FullCalendar's "+N more" popover defaults to a white page background.
  &:is(.admin-interface *) {
    --fc-page-bg-color: var(--tw-color-bg-alt);
    color: var(--tw-color-fg-base);

    .fc-timegrid-axis-frame,
    .fc-timegrid-slot-label,
    .calendar-weekday-label {
      color: var(--tw-color-fg-subtle);
    }
  }

  .fc-button-group {
    gap: 8px;
  }

  &,
  .calendar-grid {
    height: 100%;
  }

  .fc-scrollgrid {
    border: 0px;
    border-bottom: 1px solid var(--fc-border-color);
  }

  .fc-timegrid > table {
    & > thead .fc-scroller,
    & > tbody > tr:first-child .fc-scroller {
      overflow: hidden auto !important;
    }
  }

  .fc-timegrid-col-bg {
    z-index: 4;
  }

  .fc-timegrid-divider {
    padding: 0px;
  }

  .fc-scrollgrid-section-body > td {
    border-bottom: none;
    border-right: none;
  }

  th.fc-col-header-cell,
  th.fc-timegrid-axis {
    border-left: none;
    border-right: none;
    border-bottom: none;
  }

  th:last-child,
  td:last-child {
    border-right: none;
  }

  .fc-timegrid-slot {
    // TODO: updat this when we support different increments
    height: 0.75em !important;
    line-height: 0.75em !important;
  }

  .fc-timegrid-slot-minor {
    border: 0px;
  }

  .fc-timegrid-slot-label {
    border: none;
    transform: translateY(-50%);
  }

  .fc-timegrid-slot-label[data-time='00:00:00'] {
    display: none;
  }

  .fc-timegrid-axis-frame {
    margin-top: 3px; // Align baseline of time zone with weekday names in the same row
    min-height: 36px; // Reduce jumpiness
  }

  .fc-timegrid-axis-frame,
  .fc-timegrid-slot-label {
    color: var(--tw-color-neutral-600);
    font-size: var(--tw-font-size-xs);
    padding-right: 4px;
  }

  // Keep "Oct 2026" on one line: the controls chunk gives way first (see .calendar-nav-buttons)
  .fc-toolbar-chunk:has(> .fc-toolbar-title) {
    flex-shrink: 0;
  }

  .fc-toolbar-title {
    font-size: var(--tw-font-size-lg);
    font-weight: var(--tw-font-weight-semi-bold);
    text-transform: capitalize;
  }

  .fc-today-button {
    text-transform: capitalize;
  }

  .fc-col-header-cell-cushion {
    > span {
      text-transform: capitalize;
    }
  }

  // The container for `Today` and `<` `>` buttons
  // These classes are added by our js
  .calendar-nav-buttons {
    display: flex;
    gap: 8px;
    align-items: center;
    min-width: 0; // the time zone pill inside shrinks (and sheds parts) instead of wrapping the title

    .calendar-prev-next-buttons {
      gap: 4px;
      margin-left: 0px;

      .fc-icon {
        font-size: 20px;
      }
    }
  }

  .calendar-unavailable {
    background-color: rgba(0, 0, 0, 0.2);
    &:is(.dark *) {
      background-color: rgba(255, 255, 255, 0.5);
    }
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='10' height='10' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 40 40 0H20L0 20m40 20V20L20 40' fill='%2300000b' fill-opacity='.20' fill-rule='evenodd'/%3E%3C/svg%3E");
  }

  /* Event related styles*/

  // Sometimes all-day events seem to have a lot of extra margin-top. No idea why
  .fc-daygrid-event-harness,
  .fc-daygrid-day-bottom {
    margin-top: 0px !important;
  }

  // normal events have some extra ugly margin - remove it
  .fc-timegrid-col-events {
    margin-left: 0px;
    margin-right: 0px;
  }

  // Applied to all events
  .fc-event {
    border-radius: 3px;
    padding: 0 5px;

    .fc-event-main,
    &.calendar-available-virtual-event .fc-event-title {
      padding: 2px 0px 0px 4px;
    }

    // Title for all events
    .fc-event-title {
      margin: 0px;
      font-size: 12px;
      font-weight: 600;
    }
  }

  // Applied to all-day events
  .fc-daygrid-day-events {
    margin-bottom: 12px;
  }

  .fc-daygrid-event {
    margin: 1px 2px 0px;
  }

  // Applied to non all-day events
  .fc-timegrid-event {
    .fc-event-time {
      line-height: 1;
      margin-top: 3px;
      margin-bottom: 2px;
    }
  }

  // Applied to short (<=30 minutes) and very short (<=20 minutes) non all-day events
  .calendar-event-short,
  .calendar-event-very-short {
    .fc-event-time {
      font-size: 10px;
    }

    .fc-event-title {
      font-size: 10px;
      line-height: 12px;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  // Applied to very short (<=20 minutes) non all-day events
  .calendar-event-very-short {
    .fc-event-title {
      margin: 0px;
      font-size: 9px;
      line-height: 1;
    }
  }

  // Applied to virtual events (i.e those that are shown on hover, click on booking slot)
  .calendar-available-virtual-event {
    --fc-bg-event-opacity: 1;
    --fc-bg-event-color: var(--tw-color-yellow-500);
    color: white;
    cursor: pointer;

    &.calendar-available-hover {
      --fc-bg-event-opacity: 0.8;
    }

    &.calendar-available-active {
      --fc-bg-event-opacity: 1;
    }

    .fc-event-title {
      font-style: normal;
      white-space: nowrap;
    }
  }

  .calendar-available-hover {
    z-index: 5;
  }

  /* Event card styles for rich calendar events */

  .fc-daygrid-event.fc-daygrid-event {
    &:has(.calendar-event-card) {
      border: none;
      background: transparent;
      padding: 0;
      margin: 2px;
    }
  }

  .calendar-event-card {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 4px 6px;
    font-size: 11px;
    line-height: 1.3;
    overflow: hidden;
    background: rgb(var(--color-primary-500-rgb, 63, 115, 229));
    color: rgb(var(--color-primary-contrast-rgb, 255, 255, 255));
    border-radius: 4px;
    cursor: pointer;
  }

  .calendar-event-card-header {
    display: flex;
    gap: 4px;
    align-items: flex-start;
    min-width: 0;
  }

  .calendar-event-card-img {
    width: 28px;
    height: 28px;
    border-radius: 3px;
    object-fit: cover;
    flex-shrink: 0;
  }

  .calendar-event-card-titles {
    min-width: 0;
    flex: 1;
  }

  .calendar-event-card-title {
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .calendar-event-card-subtitle {
    opacity: 0.85;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .calendar-event-card-avatars {
    display: flex;
    gap: 0;
    margin-left: -2px;
  }

  .calendar-event-card-avatar {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.5);
    object-fit: cover;
    margin-left: -2px;
  }

  .calendar-event-card-avatar-initials {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.25);
    font-size: 9px;
    font-weight: 600;
  }

  .calendar-event-card-occurrence {
    opacity: 0.8;
    font-size: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

// Admin Events calendar only: bookings and group events share one 12px size, time first.
#admin-events_index .calendar-component {
  .fc-event .fc-event-title,
  .fc-event .fc-event-time {
    min-width: 0;
    margin: 0;
    overflow: hidden;
    font-size: 12px;
    line-height: 14px;
  }

  .fc-event .fc-event-time {
    display: contents;
    white-space: nowrap;

    &::after {
      content: none;
    }
  }

  .fc-event .fc-event-title {
    flex: 0 1 auto;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .calendar-event-start-time {
    flex: none;
    white-space: nowrap;
  }

  .calendar-event-end-time {
    flex: 0 100 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .fc-event-content {
    display: flex;
    column-gap: 4px;
    min-width: 0;
  }

  .fc-timegrid-event {
    .fc-event-content {
      flex-direction: column;
    }

    // Flex drops the end span's leading space, so the gap stands in for it.
    .fc-event-time {
      display: flex;
      column-gap: 4px;
    }

    &.calendar-event-short .fc-event-content,
    &.calendar-event-very-short .fc-event-content {
      flex-direction: row;
      align-items: center;
    }

    &.calendar-event-short .fc-event-time,
    &.calendar-event-very-short .fc-event-time {
      display: contents;
    }
  }
}
